import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {
    IdentificationAndApplicationName,
    Setting
} from './models/settings-service.model';
import {ConfigurationService} from './configuration.service';
import {
    FindAllByIdentificationAndApplicationNameServiceModel
} from "../../translations/services/models/translation-service.model";
import {InactiveModeService} from "./inactive-mode.service";

@Injectable({providedIn: 'root'})
export class SettingsDataService {
    private readonly api: string;
    private readonly inactiveMode = inject(InactiveModeService);
    private readonly baseEndpoint = 'configuration/settings'

    private get endpoint(): string {
        return this.inactiveMode.inactiveMode
            ? 'configuration/all-settings'
            : 'configuration/settings';
    }

    constructor(private readonly http: HttpClient, private readonly config: ConfigurationService) {
        this.api = this.config.configuration.api.backendUrl;
    }

    private buildParams(entries: Array<[key: string, val?: string | null]>): HttpParams {
        let params = new HttpParams();
        for (const [k, v] of entries) {
            if (v != null && v !== '') params = params.set(k, v);
        }
        return params;
    }

    findAllByApplicationName(applicationName: string): Observable<Setting[]> {
        const params = new HttpParams().set('name', applicationName);

        return this.http
            .get<{ _embedded: { settings: Setting[] } }>(`${this.api}/${this.endpoint}/search/findAllByApplicationName`,{params})
            .pipe(map(response => response._embedded?.settings ?? []));
    }

    findAllByIdentificationAndApplicationName(dto: IdentificationAndApplicationName): Observable<Setting[]> {
        const params = this.buildParams([
            ['name', dto.name],
            ['identification', dto.identification],
        ]);
        return this.http
            .get<FindAllByIdentificationAndApplicationNameServiceModel>(`${this.api}/${this.endpoint}/search/findAllByIdentificationAndApplicationName`, {params})
            .pipe(map((result:any) => {
                return result._embedded.settings;
            }));
    }

    addSetting(setting: Setting): Observable<Setting> {
        return this.http
            .post<Setting>(`${this.api}/${this.baseEndpoint}`, setting)
            .pipe(map((result:any) => {
                return result;
            }));
    }

    updateSetting(setting: Setting): Observable<Setting> {
        return this.http
            .patch<Setting>(`${this.api}/${this.baseEndpoint}/${setting.id}`, setting)
            .pipe(map((result: any) => {
                return result;
            }));
    }

    deleteSetting(setting: Pick<Setting, 'id'>): Observable<void> {
        return this.http.delete<void>(`${this.api}/${this.baseEndpoint}/${setting.id}`);
    }
}
